let ACDMessageMap = {
  1: {
    name: "CONST_EU_ACD_AgentSignInGroup_1",
    flow: 'CCS -> ACD',
  },
  2: {
    name: "CONST_EU_ACD_AgentSignInGroupAck_2",
    flow: 'CCS <- ACD',
  },
  3: {
    name: "CONST_EU_ACD_AgentSignOutGroup_3",
    flow: 'CCS -> ACD',
  },
  4: {
    name: "CONST_EU_ACD_AgentSignOutGroupAck_4",
    flow: 'CCS <- ACD',
  },
  5: {
    name: "CONST_EU_ACD_AgentSignInSkill_5",
    flow: 'CCS -> ACD',
  },
  6: {
    name: 'CONST_EU_ACD_AgentSignInSkillAck_6',
    flow: "CCS <- ACD",
  },
  7: {
    name: 'CONST_EU_ACD_AgentSignOutSkill_7',
    flow: "CCS -> ACD",
  },
  8: {
    name: 'CONST_EU_ACD_AgentSignOutSkillAck_8',
    flow: "CCS <- ACD",
  },
  9: {
    name: 'CONST_EU_ACD_Ring_9',
    flow: "CCS -> ACD",
  },
  10: {
    name: 'CONST_EU_ACD_RingAck_10',
    flow: "CCS <- ACD",
  },
  11: {
    name: 'CONST_EU_ACD_RequestACDCancel_11',
    flow: "CCS -> ACD",
  },
  12: {
    name: 'CONST_EU_ACD_RequestACDCancelAck_12',
    flow: "CCS <- ACD",
  },
  13: {
    name: 'CONST_EU_ACD_AgentStatusChangeEvt_13',
    flow: "CCS -> ACD",
  },
  14: {
    name: 'CONST_EU_ACD_AgentExitQueue_14',
    flow: "CCS -> ACD",
  },
  15: {
    name: 'CONST_EU_ACD_AgentExitQueueAck_15',
    flow: "ACD -> CCS",
  },
  16: {
    name: 'CONST_EU_ACD_FinishACDQueueEvt_16',
    flow: "CCS <- ACD",
  },
  17: {
    name: 'CONST_EU_ACD_AgentLoginEvt_17',
    flow: "CCS -> ACD",
  },
  18: {
    name: 'CONST_EU_ACD_ACDAgentMonitorLoginEvt_18',
    flow: "CCS -> ACD",
  },
  19: {
    name: 'CONST_EU_ACD_ACDAgentMonitorOffLineEvt_19',
    flow: "CCS -> ACD",
  },
  20: {
    name: 'CONST_EU_ACD_ACDAgentQueueUpdateEvt_20',
    flow: "ACD -> MONITOR",
  },
  21: {
    name: 'CONST_EU_ACD_ACDCallQueueUpdateEvt_21',
    flow: "ACD -> MONITOR",
  },
  22: {
    name: 'CONST_EU_ACD_ACDRequestQueueInfo_22',
    flow: "Monitor -> ACD",
  },
  23: {
    name: 'CONST_EU_ACD_ACDRequestQueueInfoAck_23',
    flow: "Monitor -> ACD",
  },
  24: {
    name: 'CONST_EU_ACD_ACDRequestAgentInfo_24',
    flow: "Monitor -> ACD",
  },
  25: {
    name: 'CONST_EU_ACD_ACDRequestAgentInfoAck_25',
    flow: "Monitor -> ACD",
  },
  26: {
    name: 'CONST_EU_ACD_ACDRequestAgentQueueList_26',
    flow: "Monitor -> ACD",
  },
  27: {
    name: 'CONST_EU_ACD_ACDRequestAgentQueueListAck_27',
    flow: "Monitor -> ACD",
  },
  28: {
    name: 'CONST_EU_ACD_ACDRequestCallQueueList_28',
    flow: "Monitor -> ACD",
  },
  29: {
    name: 'CONST_EU_ACD_ACDRequestCallQueueListAck_29',
    flow: "Monitor -> ACD",
  },
  30: {
    name: 'CONST_EU_ACD_ACDManualAllocCall_30',
    flow: "Monitor -> ACD",
  },
  31: {
    name: 'CONST_EU_ACD_ACDManualAllocCallAck_31',
    flow: "Monitor -> ACD",
  },
  32: {
    name: 'CONST_EU_ACD_ACDQueueInfoEvt_32',
    flow: "Monitor -> ACD",
  },
  33: {
    name: 'CONST_EU_ACD_ACDRequestSkillSignIn_33',
    flow: "Monitor -> ACD",
  },
  34: {
    name: 'CONST_EU_ACD_ACDRequestSkillSignInAck_34',
    flow: "Monitor -> ACD",
  },
  35: {
    name: 'CONST_EU_ACD_ACDSkillSignInAgentEvt_35',
    flow: "Monitor -> ACD",
  },
  36: {
    name: 'CONST_EU_ACD_ACDRequestQueueSkill_36',
    flow: "Monitor -> ACD",
  },
  37: {
    name: 'CONST_EU_ACD_ACDRequestQueueSkillAck_37',
    flow: "Monitor -> ACD",
  },
  38: {
    name: 'CONST_EU_ACD_ACDSkillSignOutAgentEvt_38',
    flow: "Monitor -> ACD",
  },
  39: {
    name: 'CONST_EU_ACD_ACDAgentStatusUpdateEvt_39',
    flow: "ACD -> CCM",
  },
  40: {
    name: 'CONST_EU_ACD_ACDAgentToAgentStatusUpdateEvt_40',
    flow: "座席到座席状态改变",
  },
  41: {
    name: 'CONST_EU_ACD_FUNCTION_END_41',
    flow: "",
  }
}
export default {

  showACDMessageName: function (msgfunc) {
    let acd = ACDMessageMap[msgfunc]
    if (acd)
      return acd.name
    else
      return msgfunc.toString()
  },
}